var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04499 0.500056C4.42955 0.500056 2.27574 2.65387 2.27574 5.32049C2.27574 6.4487 2.63471 7.47431 3.30138 8.29481L0.32707 11.3205C0.0706641 11.5769 0.0706641 12.0385 0.32707 12.2949C0.480916 12.4487 0.634758 12.5 0.788602 12.5C0.942445 12.5 1.14757 12.4487 1.30141 12.2949L4.3271 9.26917C5.09634 9.83326 6.07068 10.1923 7.09629 10.1923C9.71173 10.1923 11.8655 8.03844 11.8655 5.37181C11.8143 2.65381 9.71173 0.5 7.0451 0.5L7.04499 0.500056ZM7.04499 8.91037C5.0963 8.91037 3.50649 7.32063 3.50649 5.32068C3.50649 3.32062 5.09623 1.73099 7.04499 1.73099C8.99368 1.73099 10.5835 3.32073 10.5835 5.32068C10.5835 7.32074 9.04503 8.91037 7.04499 8.91037Z",
    fill: "#203140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.233815f059b2100e5fd5d83d946089b8.svg";
export { ForwardRef as ReactComponent };